package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.RentTypeDomain
import ru.villawonka.app.resources.AppResources

sealed class RentTypeUIModel {
    val key: String = AppResources.strings.rentType
    abstract val value: String

    class Daily : RentTypeUIModel() {
        override val value: String = AppResources.strings.rentTypeDaily
    }

    class Monthly : RentTypeUIModel() {
        override val value: String = AppResources.strings.rentTypeMonthly
    }

    class Annually : RentTypeUIModel() {
        override val value: String = AppResources.strings.rentTypeAnnually
    }

    class Period : RentTypeUIModel() {
        override val value: String = AppResources.strings.rentTypePeriod
    }
}

fun RentTypeDomain.toUIModel(): RentTypeUIModel = when (this) {
    RentTypeDomain.MONTHLY -> RentTypeUIModel.Monthly()
    RentTypeDomain.PERIOD -> RentTypeUIModel.Period()
    RentTypeDomain.ANNUALLY -> RentTypeUIModel.Annually()
    RentTypeDomain.DAILY -> RentTypeUIModel.Daily()
}